import { get, startCase } from "lodash";

import { PricingTypes } from "constants/pricingTypes";

const unitPriceHeader = params => {
  const { api } = params;
  const { rowModel } = api;

  if (rowModel.getRowCount() > 0) {
    const defaultPricingType = get(
      rowModel.getRow(0).data,
      "livestockSale.pricing_type_id",
    );
    return PricingTypes.toString(defaultPricingType);
  } else {
    return "Unit Price";
  }
};

/**
 * Returns a header value for nested fields, e.g. "livestockSale.title" -> "Livestock Sale Name"
 * Used for ag-Grid columnDrop headers.
 * columnDrop headers are the headers shown across the header of the grid when a column is grouped
 * We want to pull out the parent field name and add it before the header name to make it more readable
 */
function nestedHeaderValueGetter(params) {
  const { field, headerName } = params.colDef;
  if (
    params.location === "columnDrop" &&
    typeof field === "string" &&
    field.includes(".")
  ) {
    return `${startCase(field.split(".")[0])} ${headerName}`;
  }
  return headerName;
}

export default { unitPriceHeader, nestedHeaderValueGetter };
